import {
  TbAdjustments,
  TbArrowDown,
  TbArrowsExchange,
  TbCircleMinus,
  TbCirclePlus,
  TbHistory,
  TbTransferOut,
} from "react-icons/tb";

/**
 * Shared Tabler icons for Stables actions (client /stables + BaaS wallet quick actions).
 * Keep buy / sell / swap / withdraw|transfer / deposit / history in sync across surfaces.
 * BaaS "Sacar" uses the same icon as client "Sacar" (withdraw).
 * Product nav / quick-action entry uses `TbCoins` (same as Routes.tsx sidebar).
 */
export const STABLES_ACTION_ICONS = {
  buy: TbCirclePlus,
  sell: TbCircleMinus,
  swap: TbArrowsExchange,
  transfer: TbTransferOut,
  withdraw: TbTransferOut,
  history: TbHistory,
  deposit: TbArrowDown,
  limits: TbAdjustments,
};
